(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.directives.floorInput
   */
  angular
    .module("akitabox.mobile.directives.floorInput", [
      "akitabox.core.services.floor",
    ])
    .directive("abmFloorInput", AbmFloorInputDirective);

  /**
   * @ngdoc directive
   * @module akitabox.mobile.directives.floorInput
   * @name AbmFloorInputDirective
   * @restrict E
   * @description
   * `abm-floor-input` creates a dropdown menu to allow for selection of the floors
   */

  /* @ngInject */
  function AbmFloorInputDirective() {
    return {
      restrict: "E",
      templateUrl: "app/mobile/directives/floor-input/floor-input.html",
      controller: AbmFloorInputController,
      controllerAs: "vm",
      bindToController: true,
      link: postLink,
      scope: {
        inputId: "@?abmInputId",
        inputName: "@?abmInputName",
        placeholder: "@?",
        ngModel: "=",
        ngChange: "&?",
        building: "=",
      },
    };

    function postLink($scope, $element, attrs, vm) {
      vm.required = angular.isDefined(attrs.required);
      $scope.$watch("vm.building", function (newValue, oldValue) {
        resetNgModel(newValue, oldValue);
        vm.placeholder = updatePlaceholder();
      });
      /**
       * Determines if ngModel should be set to null
       *
       * @param newValue
       * @param oldValue
       */
      function resetNgModel(newValue, oldValue) {
        if (!vm.ngModel) return; // We only want to reset ngModel if there is an ngModel

        // Determine if the newValue and the oldValue has actually changed
        // Since this is a floor, it would see if the building has actually changed
        var hasChanged = (newValue && !oldValue) || (!newValue && oldValue);

        if (
          newValue &&
          oldValue &&
          Object.prototype.hasOwnProperty.call(newValue, "_id") &&
          Object.prototype.hasOwnProperty.call(oldValue, "id")
        ) {
          hasChanged = hasChanged || newValue._id !== oldValue._id;
        } else {
          hasChanged = hasChanged || newValue !== oldValue;
        }

        if (hasChanged) {
          vm.ngModel = null;
        }
      }

      /**
       * Updates the placeholder text to show a enabled and disabled mode
       *
       * @returns {*}
       */
      function updatePlaceholder() {
        if (!vm.building) {
          return "Building required";
        }

        return vm.originalPlaceholder;
      }
    }
  }

  /* @ngInject */
  function AbmFloorInputController($log, FloorService, ToastService) {
    var self = this;

    if (angular.isUndefined(self.ngModel)) {
      return $log.error("<abm-floor-input> ng-model is unassigned");
    } else if (!angular.isDefined(self.building)) {
      return $log.error("<abm-floor-input> building is unassigned");
    }

    self.isDisabled = isDisabled;
    self.querySearch = querySearch;
    self.onChange = onChange;

    self.loading = false;
    self.searchText = null;
    self.placeholder = self.placeholder || "Choose a floor";
    self.originalPlaceholder = self.placeholder;

    function isDisabled() {
      return !self.building;
    }

    function querySearch(searchText) {
      var buildingId =
        self.building && self.building._id ? self.building._id : self.building;

      if (!buildingId) {
        return [];
      }

      self.loading = true;
      return FloorService.getAll(buildingId)
        .then(function (floors) {
          if (angular.isEmpty(searchText)) {
            return floors;
          }

          return filterQuery(searchText, floors);
        })
        .catch(ToastService.showError)
        .finally(function () {
          self.loading = false;
        });
    }

    function filterQuery(searchText, matches) {
      return matches.filter(function (match) {
        return match.name.match(new RegExp(searchText, "i"));
      });
    }

    function onChange(item) {
      if (angular.isFunction(self.ngChange)) {
        self.ngChange({ value: item });
      }
    }
  }
})();
